import { MAX_ODOMETER_KM } from '@chukua/common';
import { InputNumber } from 'antd';
import type { Readings } from '../policies/receive-readings.policy';

interface ReadingsFieldsProps {
  readings: Readings;
  onChange: (readings: Readings) => void;
  disabled: boolean;
  /** Where the readings came from, so the supervisor knows whether they are confirming the driver's or entering their own. */
  provenance: string;
}

/** The two readings Receive needs. Whole numbers only, as the check records them; a driver's reading is prefilled and can be corrected here. */
export function ReadingsFields({ readings, onChange, disabled, provenance }: ReadingsFieldsProps) {
  return (
    <section aria-labelledby="readings-heading" className="rounded-xl border border-line bg-surface p-4">
      <h2 id="readings-heading" className="text-base font-semibold text-fg">
        Final readings
      </h2>
      <p className="mb-4 text-sm text-muted">{provenance}</p>
      <div className="flex flex-col gap-4">
        <label className="flex flex-col gap-1.5 text-sm font-medium text-fg">
          Odometer
          <InputNumber
            size="large"
            inputMode="numeric"
            className="w-full"
            min={0}
            max={MAX_ODOMETER_KM}
            precision={0}
            suffix="km"
            disabled={disabled}
            value={readings.odometerKm}
            onChange={(odometerKm) => onChange({ ...readings, odometerKm })}
          />
        </label>
        <label className="flex flex-col gap-1.5 text-sm font-medium text-fg">
          Fuel gauge
          <InputNumber
            size="large"
            inputMode="numeric"
            className="w-full"
            min={0}
            max={100}
            precision={0}
            suffix="%"
            disabled={disabled}
            value={readings.fuelLevelPercent}
            onChange={(fuelLevelPercent) => onChange({ ...readings, fuelLevelPercent })}
          />
        </label>
      </div>
    </section>
  );
}
